import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-panel',
  templateUrl: './two-panel.component.html',
  styleUrls: ['./two-panel.component.scss']
})
export class TwoPanelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
